import { render, staticRenderFns } from "./FacilityTerm.vue?vue&type=template&id=31777a2e&"
import script from "./FacilityTerm.vue?vue&type=script&lang=js&"
export * from "./FacilityTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports